import React, {useContext, useState} from 'react';
import Popup from './Popup';
import {getLogsApi} from '../api/getApiData';
import {UserContext} from '../context/userContext';
import {FilterContext} from '../context/filterContext';
import {getFullNameById} from '../functions/utils';
import Loader from './Loader';
import {AuthContext} from '../context/authContext';
import '../../../assests/css/logs.scss';

export interface logsType {
    id: number,
    logText: string,
    createdById: number,
    createdDateTime: string,
}

interface logsPropsType {
    btnCustomClassName?: string,
}

export default function Logs(props: logsPropsType) {

    const {data: {permissions}} = useContext(UserContext);
    const {filterData: {users}} = useContext(FilterContext);
    const {accounts} = useContext(AuthContext);
    const [show, setShow] = useState(false);
    const [logs, setLogs] = useState<logsType[]>([]);
    const [loading, setLoading] = useState(false);

    const getLogs = async () => {
        setLoading(true);
        const noLimit= permissions.includes('A');
        const {value}= await getLogsApi(`Logs/?$orderby=createdDateTime desc`,
            accounts);
        if (value) {
            if (!noLimit) {
                const temp = value.slice(0, 5);
                setLogs(temp);
            } else {
                setLogs(value);
            }
        }
        setLoading(false);
    }

    const handleShowLogs = () => {
        setShow(true);
        getLogs();
    }

    return (
        <div className="logs-container">
            <Popup title='Logs' show={show} onClose={()=> setShow(false)}
                size='lg' customClassName='logs-bg'>
                <div className="logs-content">
                    {!loading? logs.map((log, index)=> {
                        return (
                            <div key={`log-${index}`}
                                className="log-content">
                                <div className="log-details">
                                    <span className="logged-by-name">
                                        {getFullNameById(log.createdById,
                                            users)}
                                    </span>
                                    <span className="logged-time">
                                        {new Date(log.createdDateTime)
                                            .toString()}
                                    </span>
                                </div>
                                <div className="log-text-content">
                                    <span className="log-text">
                                        {log.logText}
                                    </span>
                                </div>
                            </div>
                        )
                    }): <Loader/>}
                </div>
            </Popup>
            <button
                onClick={handleShowLogs}
                className={props.btnCustomClassName}
            >Logs</button>
        </div>
    );

}